import { PaymentMethodControllerOptionFragment } from "./UserBillingSelect-generated.hooks";

export const formatSavedPaymentLabel = (
  paymentMethod: PaymentMethodControllerOptionFragment,
) => {
  switch (paymentMethod.billingType) {
    case "A":
      return `Bank ********* ****${paymentMethod.billingLastFour}`;
    case "C":
      return `Card **** **** **** ${paymentMethod.billingLastFour}`;
    case "L":
      return `Stripe Link`;
    default:
      return `Bank ********* ****${paymentMethod.billingLastFour}`;
  }
};

export const CASH_UUID = "CASH";
export const CASH_OPTION: PaymentMethodControllerOptionFragment = {
  uuid: CASH_UUID,
  billingType: "Cash / Check",
  billingLastFour: "",
};

export const COMP_UUID = "bil_1111111111111";
export const COMP_OPTION: PaymentMethodControllerOptionFragment = {
  uuid: COMP_UUID,
  billingType: "Comp",
  billingLastFour: "",
};

export const COMP_BIL_UUID = "bil_1111111111111";
export const CASH_BIL_UUID = "bil_0000000000000";
export const PEND_BIL_UUID = "bil_3333333333333";
export function getBillingUuid(uuid: string) {
  if (uuid === COMP_UUID) {
    return COMP_BIL_UUID;
  }

  if (uuid === CASH_UUID) {
    return CASH_BIL_UUID;
  }

  if (uuid === PEND_BIL_UUID) {
    return PEND_BIL_UUID;
  }

  return uuid;
}
